import * as React from 'react'
import { Toast } from './toast'
import { Toasts } from './use-toasts'

export const ToasterRoot = () => {
  const store = Toasts.use()

  return (
    <div className="toaster">
      {store.toasts.map((x) => (
        <Toast key={x.id} content={x.content} onClick={x.onCancel} />
      ))}
    </div>
  )
}
